import { useQuery } from "@tanstack/react-query";

import { notificacoesAdminQueries } from "@/services/api/queries/notificacoes-admin.queries";
import { PeriodoResumoNotificacao } from "@/types/notificacao-log.type";

export function useNotificacaoLogKpis(dias: PeriodoResumoNotificacao) {
  const { data, isLoading } = useQuery(notificacoesAdminQueries.logsResumo(dias));

  return {
    resumo: data || { totalEnviadas: 0, totalFalhas: 0, totalIgnoradas: 0, totalGeral: 0 },
    loading: isLoading,
  };
}
